import { match as ogImage } from "../../../src/params/ogImage.ts";

export const matchers = { ogImage };